import { render, staticRenderFns } from "./CustomerAdvocate2.vue?vue&type=template&id=20379645&"
import script from "./CustomerAdvocate2.vue?vue&type=script&lang=js&"
export * from "./CustomerAdvocate2.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAdvocate2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports